/**
 * OAuth URL helpers for web and native iOS Browser.open flows.
 */

export const getOAuthBackendOrigin = () => {
  if (process.env.REACT_APP_SERVER_ORIGIN) {
    return process.env.REACT_APP_SERVER_ORIGIN;
  }

  const { protocol, hostname, port, origin } = window.location;
  if (protocol !== 'https:' && protocol !== 'http:') {
    return null;
  }

  const isReactDevServer = port === '3000';
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  if (isLocalhost || isReactDevServer) {
    return `${protocol}//${hostname}:8080`;
  }

  return origin;
};

export const buildOAuthStartUrl = (provider) => {
  const backendOrigin = getOAuthBackendOrigin();
  if (!backendOrigin) return null;
  return new URL(`${backendOrigin}/api/auth/${provider}`);
};
